const messages = import.meta.glob('/src/lang/*.json', { eager: true })

export function loadLocaleMessages(locale: string) {
	const file = messages[`/src/lang/${locale}.json`]
	if (!file) throw new Error(`Idioma no encontrado: ${locale}`)
	return file
}
